/**
 * Knowledge base likes.
 *
 * Both the like counts and "have I already liked this" are read from the
 * server after load rather than taken from the markup. The pages are held in
 * a full-page cache, so the HTML carries whatever was true when it was
 * cached — the counter froze at that number and the button always came back
 * un-liked on reload. This mirrors what views-archive.js does for view
 * counts. The liked flag has to come from the server too: the cookie
 * recording it is httpOnly, so document.cookie can never see it.
 */
document.addEventListener('DOMContentLoaded', () => {
    const ajaxUrl =
        (window.pifagorBzData && window.pifagorBzData.ajaxUrl) ||
        window.ajaxurl ||
        '/wp-admin/admin-ajax.php';

    const likedSvg = `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_5835_53729)">
                <mask id="mask0_5835_53729" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                    <path d="M24 0H0V24H24V0Z" fill="white"/>
                </mask>
                <g mask="url(#mask0_5835_53729)">
                    <path opacity="0.4" d="M21.6499 10.0307C21.2599 9.47071 20.5699 9.15071 19.7799 9.15071H15.6799C15.4099 9.15071 15.1599 9.04071 14.9899 8.84071C14.8099 8.64071 14.7399 8.36071 14.7799 8.07071L15.2899 4.79071C15.5099 3.81071 14.8599 2.71071 13.8799 2.38071C12.9699 2.04071 11.8999 2.50071 11.4699 3.15071L7.24988 9.42071L7.12988 9.62071V18.4607L7.27988 18.6107L10.4499 21.0607C10.8699 21.4807 11.8199 21.7107 12.4899 21.7107H16.3899C17.7299 21.7107 19.0799 20.7007 19.3799 19.4707L21.8399 11.9807C22.0999 11.2707 22.0299 10.5807 21.6499 10.0307Z" fill="#1B67FF"/>
                    <path d="M5.21 6.38086H4.18C2.63 6.38086 2 6.98086 2 8.46086V18.5209C2 20.0009 2.63 20.6009 4.18 20.6009H5.21C6.76 20.6009 7.39 20.0009 7.39 18.5209V8.46086C7.39 6.98086 6.76 6.38086 5.21 6.38086Z" fill="#1B67FF"/>
                </g>
            </g>
            <defs>
                <clipPath id="clip0_5835_53729">
                    <rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    `;

    const formatCount = (n) => Number(n).toLocaleString('uk-UA');

    const setLikedIcon = (el) => {
        const icon = el.querySelector('svg');
        if (icon) icon.outerHTML = likedSvg;
    };

    const writeCount = (el, count) => {
        const countEl = el.querySelector('.js-bz-like-count');
        if (countEl) countEl.textContent = formatCount(count);

        // The label is baked into the cached HTML the same way the number is.
        if (el.hasAttribute('aria-label')) {
            el.setAttribute('aria-label', formatCount(count) + ' лайків');
        }
    };

    const markLiked = (el) => {
        el.classList.add('is-liked');
        setLikedIcon(el);
        if (el.tagName === 'BUTTON') el.disabled = true;
    };

    // On the listing/chip/related markup the icon means "this has any likes"
    // (PHP picks the filled one when the count is above zero), while on the
    // button it means "you liked it". So a card whose count was cached at 0
    // and hydrates to more still needs its icon swapped; the button must not.
    const syncCardIcon = (el, count) => {
        if (el.tagName === 'BUTTON') return;
        if (count > 0) setLikedIcon(el);
    };

    // Every element showing a like count, keyed by post id — one post can
    // appear more than once on a page (button plus a related-questions card).
    const targets = new Map();

    document.querySelectorAll('[data-bz-likes]').forEach((el) => {
        const id = el.getAttribute('data-bz-likes');
        if (!id) return;
        if (!targets.has(id)) targets.set(id, []);
        targets.get(id).push(el);
    });

    if (!targets.size) return;

    const hydrate = () => {
        const body = new URLSearchParams();
        body.append('action', 'pifagor_bz_get_likes');
        targets.forEach((_els, id) => body.append('ids[]', id));

        fetch(ajaxUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString(),
            credentials: 'same-origin',
        })
            .then((r) => r.json())
            .then((res) => {
                if (!res || !res.success || !res.data || !res.data.items) return;

                Object.keys(res.data.items).forEach((id) => {
                    const item = res.data.items[id];
                    (targets.get(id) || []).forEach((el) => {
                        writeCount(el, item.count);
                        syncCardIcon(el, item.count);
                        if (item.liked) markLiked(el);
                    });
                });
            })
            .catch(() => {});
    };

    hydrate();

    // Back/forward cache restores the DOM as it was left, counts included.
    window.addEventListener('pageshow', (e) => {
        if (e.persisted) hydrate();
    });

    const btn = document.querySelector('.js-bz-like');
    if (!btn) return;

    const postId = btn.dataset.postId;
    let isRequestPending = false;

    btn.addEventListener('click', () => {
        if (isRequestPending || btn.classList.contains('is-liked')) return;
        isRequestPending = true;
        btn.disabled = true;

        const body = new URLSearchParams({
            action: 'pifagor_bz_like',
            post_id: postId,
        });

        fetch(ajaxUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString(),
            credentials: 'same-origin',
        })
            .then((r) => r.json())
            .then((res) => {
                if (!res || !res.success) return;

                // Update every spot showing this post, not just the button.
                (targets.get(String(postId)) || [btn]).forEach((el) => {
                    writeCount(el, res.data.count);
                    syncCardIcon(el, res.data.count);
                    if (res.data.liked) markLiked(el);
                });
            })
            .catch(() => {})
            .finally(() => {
                isRequestPending = false;
                btn.disabled = btn.classList.contains('is-liked');
            });
    });
});
